window.theme = window.theme || {};

theme.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  document.addEventListener('shopify:section:load', this._onSectionLoad.bind(this));
  document.addEventListener('shopify:section:unload', this._onSectionUnload.bind(this));
  document.addEventListener('shopify:section:select', this._onSelect.bind(this));
  document.addEventListener('shopify:section:deselect', this._onDeselect.bind(this));
  document.addEventListener('shopify:block:select', this._onBlockSelect.bind(this));
  document.addEventListener('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

theme.Sections.prototype = Object.assign({}, theme.Sections.prototype, {
  _createInstance: function (container, constructor) {
    var id = container.getAttribute('data-section-id');
    var type = container.getAttribute('data-section-type');
    constructor = constructor || this.constructors[type];
    if (typeof constructor === 'undefined') return;
    var instance = Object.assign(new constructor(container), { id: id, type: type, container: container });
    this.instances.push(instance);
  },
  _onSectionLoad: function (evt) {
    var container = document.querySelector('[data-section-id="' + evt.detail.sectionId + '"]');
    if (container) this._createInstance(container);
  },
  _onSectionUnload: function (evt) {
    this.instances = this.instances.filter(function (instance) {
      var isEventInstance = instance.id === evt.detail.sectionId;
      if (isEventInstance && typeof instance.onUnload === 'function') instance.onUnload(evt);
      return !isEventInstance;
    });
  },
  _onSelect: function (evt) {
    var instance = this.instances.find(function (instance) { return instance.id === evt.detail.sectionId; });
    if (typeof instance !== 'undefined' && typeof instance.onSelect === 'function') instance.onSelect(evt);
  },
  _onDeselect: function (evt) {
    var instance = this.instances.find(function (instance) { return instance.id === evt.detail.sectionId; });
    if (typeof instance !== 'undefined' && typeof instance.onDeselect === 'function') instance.onDeselect(evt);
  },
  _onBlockSelect: function (evt) {
    var instance = this.instances.find(function (instance) { return instance.id === evt.detail.sectionId; });
    if (typeof instance !== 'undefined' && typeof instance.onBlockSelect === 'function') instance.onBlockSelect(evt);
  },
  _onBlockDeselect: function (evt) {
    var instance = this.instances.find(function (instance) { return instance.id === evt.detail.sectionId; });
    if (typeof instance !== 'undefined' && typeof instance.onBlockDeselect === 'function') instance.onBlockDeselect(evt);
  },
  register: function (type, constructor) {
    this.constructors[type] = constructor;
    document.querySelectorAll('[data-section-type="' + type + '"]').forEach(function (container) {
      this._createInstance(container, constructor);
    }.bind(this));
  }
});

theme.collectionSlider = (function () {
  function sliderProduct(e) {
    let sliderContainer = '', extraLargeDesktopShow = 4, largeDesktopShow = 3, tabletShow = 3, mobileShow = 2,
      sliderRows = parseInt(e.dataset.sliderRows), sliderGrid = 'column', sliderLoop = e.dataset.loop;
    sliderLoop = sliderLoop === 'true';
    if (sliderRows > 1) { sliderGrid = 'row'; sliderLoop = false; }
    if (e.dataset.sliderEnable === 'true') {
      sliderContainer = e.querySelector('.productSlider');
      extraLargeDesktopShow = parseInt(e.dataset.showExtraLarge);
      largeDesktopShow = parseInt(e.dataset.showLarge);
      tabletShow = parseInt(e.dataset.showTablet);
      mobileShow = parseInt(e.dataset.showMobile);
    }
    var swiper = new Swiper(sliderContainer, {
      loop: sliderLoop, slidesPerView: mobileShow, spaceBetween: 20,
      grid: { rows: sliderRows, fill: sliderGrid },
      pagination: { el: e.querySelector('.swiper-pagination'), clickable: true },
      navigation: {
        nextEl: e.querySelector('.product_slider_wrapper .swiper-button-next'),
        prevEl: e.querySelector('.product_slider_wrapper .swiper-button-prev')
      },
      breakpoints: { 640: { slidesPerView: mobileShow }, 750: { slidesPerView: tabletShow }, 992: { slidesPerView: largeDesktopShow }, 1200: { slidesPerView: extraLargeDesktopShow } }
    });
    const slideThumbHeight = () => {
      const t = e.querySelectorAll('.card--client-height');
      if (t.length > 0) e.style.setProperty('--slider-navigation-top-offset', `${t[0].clientHeight / 2}px`);
    };
    slideThumbHeight();
    window.addEventListener('resize', slideThumbHeight);
  }
  return sliderProduct;
})();

(function() {
  if ('requestIdleCallback' in window) requestIdleCallback(function() {});
  else setTimeout(function() {}, 200);
})();

document.addEventListener('DOMContentLoaded', function () {
  let sections = new theme.Sections(),
    headerSearchModule = new theme.Sections(),
    headerStickyModule = new theme.Sections();
  sections.register('announcement-bar', theme.announcement);
  sections.register('header', theme.headerSection);
  sections.register('header', theme.headerCategoryMenu);
  headerSearchModule.register('header', theme.headerSearch);
  headerStickyModule.register('header', theme.headerSticky);
  sections.register('footer', theme.footerSection);
  sections.register('slideShow', theme.SlideShow);
  sections.register('product-tab', theme.productTab);
  sections.register('collection-product', theme.collectionProduct);
  sections.register('product-slider', theme.collectionSlider);
  sections.register('faq-collapse', theme.accordion);
  sections.register('popup-video', theme.video);
  sections.register('lookbook', theme.lookbookSlider);
  sections.register('timeline', theme.timelineSlider);
});

// ── Uncensoredvibes Header Enhancements ──────────────────────────────────────
(function() {
  var UV_PINK = '#ee2761';

  function injectStyles() {
    if (document.getElementById('uv-header-styles')) return;
    var s = document.createElement('style');
    s.id = 'uv-header-styles';
    s.textContent = [
      '.uv-home-btn{display:inline-flex;align-items:center;gap:5px;padding:6px 11px;border-radius:8px;border:1px solid rgba(0,0,0,0.13);color:inherit;text-decoration:none;font-size:13px;font-weight:500;margin-right:6px;white-space:nowrap;flex-shrink:0;line-height:1;}',
      '.uv-home-btn:hover{background:rgba(0,0,0,0.05);color:inherit;text-decoration:none;}',
      '.uv-home-btn svg{width:16px;height:16px;flex-shrink:0;}',
      '.header__actions_btn--cart.uv-cart-pill{background:' + UV_PINK + '!important;color:#fff!important;border-radius:50px!important;padding:7px 15px!important;gap:6px!important;display:flex!important;align-items:center!important;}',
      '.header__actions_btn--cart.uv-cart-pill svg{color:#fff!important;width:18px!important;}',
      '.header__actions_btn--cart.uv-cart-pill .header__actions_btn_cart_num{background:#fff!important;color:' + UV_PINK + '!important;position:static!important;width:20px!important;height:20px!important;font-size:11px!important;top:auto!important;right:auto!important;}',
      '.uv-cart-label{font-size:13px;font-weight:500;}',
      '.uv-signup-btn{display:inline-flex!important;align-items:center!important;gap:4px!important;border:1.5px solid ' + UV_PINK + '!important;color:' + UV_PINK + '!important;border-radius:50px!important;padding:5px 13px!important;font-size:13px!important;font-weight:500!important;text-decoration:none!important;background:transparent!important;cursor:pointer;}',
      '.uv-signup-btn:hover{background:rgba(238,39,97,0.06)!important;color:' + UV_PINK + '!important;text-decoration:none!important;}',
      '.uv-signup-btn svg{width:16px!important;height:16px!important;color:' + UV_PINK + '!important;}',
      '.uv-signup-text{white-space:nowrap;}',
      '.uv-order-btn{display:inline-flex;align-items:center;gap:5px;padding:6px 12px;border-radius:8px;border:1px solid rgba(0,0,0,0.13);color:inherit;text-decoration:none;font-size:13px;font-weight:500;white-space:nowrap;flex-shrink:0;line-height:1;margin-right:4px;}',
      '.uv-order-btn:hover{background:rgba(0,0,0,0.05);color:inherit;text-decoration:none;}',
      '.uv-order-btn svg{width:16px;height:16px;flex-shrink:0;}',
      '@media(max-width:767px){.uv-home-btn .uv-home-text{display:none;}.uv-signup-text{display:none;}.uv-cart-label{display:none;}.header__actions_btn--cart.uv-cart-pill{padding:8px!important;}.uv-order-text{display:none;}}'  
    ].join('');
    document.head.appendChild(s);
  }

  function addHomeButton() {
    if (document.querySelector('.uv-home-btn')) return;
    var logo = document.querySelector('a.header__logo_link');
    if (!logo) return;
    var btn = document.createElement('a');
    btn.href = '/';
    btn.className = 'uv-home-btn';
    btn.setAttribute('aria-label', 'Go to homepage');
    btn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/></svg><span class="uv-home-text">Home</span>';
    logo.parentNode.insertBefore(btn, logo);
  }

  function enhanceCart() {
    var cart = document.querySelector('.header__actions_btn--cart');
    if (!cart || cart.classList.contains('uv-cart-pill')) return;
    cart.classList.add('uv-cart-pill');
    var label = document.createElement('span');
    label.className = 'uv-cart-label';
    label.textContent = 'Cart';
    cart.appendChild(label);
    var badge = cart.querySelector('.header__actions_btn_cart_num');
    if (badge) cart.appendChild(badge);
  }

  function enhanceAccount() {
    var btns = document.querySelectorAll('.header__actions a, .header__actions button');
    btns.forEach(function(el) {
      if (el.classList.contains('uv-signup-btn') || el.classList.contains('header__actions_btn--cart') || el.classList.contains('uv-order-btn')) return;
      if (el.href && el.href.indexOf('account') > -1) {
        el.classList.add('uv-signup-btn');
        var txt = document.createElement('span');
        txt.className = 'uv-signup-text';
        txt.textContent = 'Sign up';
        el.appendChild(txt);
      }
    });
  }

  function addOrderStatusButton() {
    if (document.querySelector('.uv-order-btn')) return;
    var actionsArea = document.querySelector('.header__actions');
    if (!actionsArea) return;
    var btn = document.createElement('a');
    btn.href = '/account';
    btn.className = 'uv-order-btn';
    btn.setAttribute('aria-label', 'Check order status');
    btn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 17H7A5 5 0 0 1 7 7h2"/><path d="M15 7h2a5 5 0 0 1 0 10h-2"/><line x1="8" y1="12" x2="16" y2="12"/></svg><span class="uv-order-text">Order Status</span>';
    var cartBtn = actionsArea.querySelector('.header__actions_btn--cart');
    if (cartBtn) {
      actionsArea.insertBefore(btn, cartBtn);
    } else {
      actionsArea.appendChild(btn);
    }
  }

  function run() {
    injectStyles();
    addHomeButton();
    enhanceCart();
    enhanceAccount();
    addOrderStatusButton();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
